import React, { useEffect, useState, useRef } from 'react';
const testimonials = [{
  quote: "Mateo's vast design knowledge was so helpful during my studies. Far beyond just a designer, Mateo brings a holistic approach to product development. He is so passionate about his work - and it shows!",
  name: 'ALEX HOLDER',
  title: "DESIGN @ DICK'S SPORTING GOODS",
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Alex.jpg'
}, {
  quote: 'Mateo was the TA for our UX Design Bootcamp. He always made himself available and went out of his way to help us achieve our goals. He clearly has a deep understanding of the field.',
  name: 'ERIC LAMONTAGNE',
  title: 'WEB STRATEGY TECHNICAL LEAD',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Eric.jpg'
}, {
  quote: 'Mateo is a great person to work with and I would be happy to be a reference for him.',
  name: 'TRACEY JACKSON',
  title: 'A11Y SPECIALIST, US BANK',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Tracey.jpg'
}];
export function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target === sectionRef.current) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section className="bg-white" data-id="element-2085">
      <div ref={sectionRef} className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8" data-id="element-2086">
        <div className="container mx-auto max-w-6xl" data-id="element-2087">
          <h2 className="text-2xl sm:text-4xl md:text-5xl text-center mb-10 sm:mb-16 md:mb-20 uppercase leading-tight text-gray-800" style={{
          fontFamily: "'Gefika', sans-serif",
          fontWeight: 400,
          letterSpacing: '0.02em',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }} data-id="element-2088">
            CLIENT & CO-WORKER COMMENTS
          </h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s'
        }} data-id="element-2089">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 sm:p-8 shadow-sm border border-gray-100 rounded-sm" data-id="element-2090">
                <p className="text-[#444444] leading-relaxed mb-6 text-base sm:text-lg font-switzer" data-id="element-2091">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center" data-id="element-2092">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden mr-3" data-id="element-2093">
                    <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover transition-all duration-300 grayscale hover:grayscale-0" data-id="element-2094" />
                  </div>
                  <div data-id="element-2095">
                    <p className="font-medium text-gray-900 text-sm sm:text-base tracking-wider font-switzer" data-id="element-2096">
                      {testimonial.name}
                    </p>
                    <p className="text-gray-600 text-xs sm:text-sm tracking-wider font-switzer" data-id="element-2097">
                      {testimonial.title}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}